module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Medium.555caafe.eot";